/* eslint-disable import/prefer-default-export */
import React from 'react';

export const isOpenContext = React.createContext(false);
